module.exports = __webpack_public_path__ + "img/cdiac_hover.97dcd4ea.svg";